



































































































































































































































































































































































































































































































































































































































































































































































































































































import DialogoDeEdicaoDeFornecedor from '@/components/fornecedor/DialogoDeEdicaoDeFornecedor.vue'
import BuscaDeProdutoDropdown from '@/components/produto/BuscaDeProdutoDropdown.vue'
import { ImportacaoDeNota, ProdutoDaImportacao } from '@/models/ImportacaoDeNota'
import { fixarCasasDecimais, formatarCnpjOuCpf } from '@/shareds/formatadores'
import { obrigatorio } from '@/shareds/regras-de-form'
import { criarProduto } from '@/shareds/produto-shareds'
import { normalizarValorDeAtributo, normalizarValoresDosAtributosDoProduto } from '@/shareds/produto-shareds'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { FinalizarImportacaoDeNotaDoFornecedorUseCase, FindAtributoUseCase, FindGradeDeProdutosUseCase, FindImportacaoUseCase, ImportarNotaDoFornecedorUseCase, FindProdutoUseCase } from '@/usecases'
import { Vue, Component, Ref, Watch } from 'vue-property-decorator'
import ProdutoDaImportacaoDeNota from "./ProdutoDaImportacaoDeNota.vue"
import SeletorDeMarca from '@/components/produto/SeletorDeMarca.vue'
import { AtributoDoProduto, Marca, Produto, Variacao, Variante } from '@/models'
import SeletorDeTag from '@/components/produto/SeletorDeTag.vue'
import SeletorDeCategoria from '../produtos/EdicaoDeProduto/SeletorDeCategoria.vue'
import SeletorDeEstacao from '@/components/produto/SeletorDeEstacao.vue'
import SeletorDeGenero from '@/components/produto/SeletorDeGenero.vue'
import { round } from '@/shareds/number-utils'
import CampoDePercentual from '@/components/ui/CampoDePercentual.vue'
import { uploadFilesToS3 } from '@/shareds/s3/files'
import Confirmacao from '@/components/ui/Confirmacao.vue'
import CampoDecimal from '@/components/ui/CampoDecimal.vue'
import DialogoDeSelecaoDeGradeDeProdutos from '@/components/produto/DialogoDeSelecaoDeGradeDeProdutos.vue'
import cartesianProduct from 'cartesian-product'
import SeletorDeNcm from '@/components/ui/SeletorDeNcm.vue'
import SeletorDeUnidadeDeMedida from '@/components/produto/SeletorDeUnidadeDeMedida.vue'
import DialogoDeAdicionarCor from '@/components/produto/DialogoDeAdicionarCor.vue'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import AppStore from '@/store/vuex/aplicacao/AppStore'
import * as LZString from 'lz-string'
const IMPORTACAO_DE_NOTA = 'IMPORTACAO_DE_NOTA'

@Component({
	components: {
		BuscaDeProdutoDropdown,
		DialogoDeSelecaoDeGradeDeProdutos,
		DialogoDeEdicaoDeFornecedor,
		ProdutoDaImportacaoDeNota,
		SeletorDeMarca,
		SeletorDeTag,
		SeletorDeCategoria,
		SeletorDeEstacao,
		SeletorDeGenero,
		CampoDePercentual,
		Confirmacao,
		SeletorDeNcm,
		SeletorDeUnidadeDeMedida,
		DialogoDeAdicionarCor,
	},
})
export default class TelaDeImportacaoDeNotaAntiga extends Vue {
	@Ref() form!: HTMLFormElement
	@Ref() dialogoDeFornecedor!: DialogoDeEdicaoDeFornecedor
	@Ref() dialogoDeSelecaoDeGradeDeProdutos!: DialogoDeSelecaoDeGradeDeProdutos
	@Ref() dialogoDeAdicionarCor!: DialogoDeAdicionarCor
	@Ref() confirmarAlteracaoDaMargemDeLucro!: Confirmacao
	@Ref() confirmarAlteracaoDasMarcas!: Confirmacao
	@Ref() campoDeMargemDeLucro!: CampoDecimal

	AlertModule = AlertModule

	importarNotaDoFornecedorUseCase = new ImportarNotaDoFornecedorUseCase()
	finalizarImportacaoDeNotaDoFornecedorUseCase = new FinalizarImportacaoDeNotaDoFornecedorUseCase()
	findGradeDeProdutosUseCase = new FindGradeDeProdutosUseCase()
	findAtributosUseCase = new FindAtributoUseCase()
	findImportacaoUseCase = new FindImportacaoUseCase()
	findSkusUseCase = new FindProdutoUseCase()

	formatarCnpjOuCpf = formatarCnpjOuCpf
	obrigatorio = obrigatorio
	fixarCasasDecimais = fixarCasasDecimais
	file: File | null = null
	carregando = false
	criandoFornecedor = false
	enviando = false
	salvandoEdicaoDeProduto = false
	margemArredondamentoAcima = 0.99
	margemArredondamentoAbaixo = 0.00
	importacaoDeNota: ImportacaoDeNota | null = (() => {
		try {
			const raw = localStorage.getItem(IMPORTACAO_DE_NOTA)
			if (!raw) return null
			const json = LZString.decompress(raw) ?? raw
			return JSON.parse(json)
		} catch {
			return null
		}
	})()
	mostrarDialogoDeEdicaoDeProduto = false
	produtoEmEdicao: Produto = {} as Produto
	indiceEmEdicao = 0
	margemDeLucroGeral = 0
	naoDeveMovimentarEstoque = false
	naoDeveAtualizarTabelaDePreco = false
	naoUtilizarArredondamentoDecimal = false
	gerandoVariantes = false
	podeFinalizar = false
	carregandoInicioDoProcessoDeImportacao: string | null = null

	arquivosEmProcessamento: ImportacaoDeNota[] = []
	carregandoStatusProcessamento = false
	intervaloDeBusca: number | null = null
	dialogoErro = false
	arquivoComErro: any = null

	snackbar = false;
	snackbarText = '';
	snackbarColor = 'success';

	headersProcessamento = [
		{ text: 'Numero da Nota', value: 'numeroNota', sortable: true },
		{ text: 'Status', value: 'status', sortable: true, align: 'center' },
		{ text: 'Data/Hora', value: 'dataHora', sortable: true },
		{ text: 'Progresso', value: 'progresso', sortable: false, align: 'center' },
		{ text: 'Ações', value: 'acoes', sortable: false, align: 'end' },
	]

	headersComCriacaoDeProduto = [
		{ text: 'Nome', value: 'nota.xProd' },
		{ text: 'Marca', value: 'encontrado.marca.nome' },
		{ text: 'Cod. do fornecedor', value: 'nota.cProd'},
		{ text: 'Quantidade', value: 'nota.qCom'},
		{ text: 'Valor un.', value: 'nota.vUnCom'},
		{ text: 'Valor total', value: 'nota.vProd'},
		{ text: 'Preço de venda varejo', value: 'precoFinalVarejo'},
		{ text: 'Margem de lucro', value: 'margemDeLucro' },
		{ text: 'Produto associado', value: 'encontrado' },
	]

	headersSemCriacaoDeProduto = [
		{ text: 'Nome', value: 'nota.xProd' },
		{ text: 'Cod. do fornecedor', value: 'nota.cProd'},
		{ text: 'Quantidade', value: 'nota.qCom'},
		{ text: 'Valor un.', value: 'nota.vUnCom'},
		{ text: 'Valor total', value: 'nota.vProd'},
		{ text: 'Produto associado', value: 'encontrado' },
	]

	get podeCriarProduto() {
		return (this.importacaoDeNota && this.importacaoDeNota.lojaDestinoDaImportacao.configuracaoDaLoja &&
											this.importacaoDeNota.lojaDestinoDaImportacao.configuracaoDaLoja.criarProdutoImportacaoEntrada)
	}

	get editandoProdutoJaCadastrado() {
		return this.produtoEmEdicao && !!this.produtoEmEdicao.id
	}

	get contadorProcessando() {
		return this.arquivosEmProcessamento.filter(f => f.status === 'Em Andamento').length
	}

	get contadorConcluidos() {
		return this.arquivosEmProcessamento.filter(f => f.status === 'Concluído').length
	}

	get contadorErros() {
		return this.arquivosEmProcessamento.filter(f => f.status === 'Incompleto').length
	}

	get contadorPendente() {
		return this.arquivosEmProcessamento.filter(f => f.status === 'Pendente').length
	}

	verificaSeCriaProduto(item: ProdutoDaImportacao, importacaoDeNota) {
		return (
			(item.encontrado && item.encontrado.id) 
			|| importacaoDeNota 
			&& (importacaoDeNota.lojaDestinoDaImportacao.configuracaoDaLoja && !importacaoDeNota.lojaDestinoDaImportacao.configuracaoDaLoja.criarProdutoImportacaoEntrada)
		) && item.encontrado && item.encontrado.tipo !== 'Com Variantes'
	}

	quantidadesInformadasValidas() {
		if (!this.importacaoDeNota) return true
		if (this.importacaoDeNota.produtos.filter(produto => produto.encontrado && produto.encontrado.tipo === 'Com Variantes').length === 0) return true

		const quantidadeInformadaTotal = this.importacaoDeNota.produtos.filter(produto => produto.encontrado && produto.encontrado.tipo === 'Com Variantes').map(produto => produto.quantidadeInformada||0).reduce((total, valor) => total + valor)
		const quantidadeEsperadaTotal = this.importacaoDeNota.produtos.filter(produto => produto.encontrado && produto.encontrado.tipo === 'Com Variantes').map(produto => parseInt(produto.nota.qCom)||0).reduce((total, valor) => total + valor)
		return quantidadeInformadaTotal === quantidadeEsperadaTotal
	}
	
	get usuario() {
		return UserLoginStore.usuario?.id
	}

	get permiteAbrirDiversosProcessosDeImportacao(){
		if(!UserLoginStore.perfil) return false
		return UserLoginStore.perfil.permissoes.includes('permite-abrir-diversos-processos')
	}

	async importarNota() {
		try {
			this.carregando = true

			
			if(!this.usuario) return

			if(!this.permiteAbrirDiversosProcessosDeImportacao){
				const possuiProcessoEmAberto = await this.findImportacaoUseCase.possuiImportacoesEmAbertoNoUsuarioLogado(this.usuario);

				if(!possuiProcessoEmAberto){
					AlertModule.setError('Já existe um processo em aberto para o usuario, aguarde finalizar para prosseguir!');
					this.carregando = false;
					return
				}
			}

			await this.importarNotaDoFornecedorUseCase.execute(
				this.file,
			);

			this.buscarItensDeImportacao()
			AlertModule.setWarning('Leitura do XML iniciada. Aguarde a finalização do processamento para completar a importação da nota');
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.carregando = false
			this.file = null
		}
	}

	created() {
		if (this.importacaoDeNota) {
			for (let i = 0;i < this.importacaoDeNota.produtos.length; i++) {
				this.importacaoDeNota.produtos[i].indice = i
			}
		}

		this.buscarItensDeImportacao();
	}

	getStatusColor(status: string): string {
		const colors = {
			Pendente: 'orange darken-2',
			'Em Andamento': 'blue',
			Concluído: 'success',
			Incompleto: 'error',
		}
		return colors[status] || 'grey'
	}

	getStatusIcon(status: string): string {
		const icons = {
			Pendente: 'mdi-clock-outline',
			'Em Andamento': 'mdi-loading mdi-spin',
			Concluído: 'mdi-check-circle',
			Incompleto: 'mdi-alert-circle',
		}
		return icons[status] || 'mdi-help-circle'
	}

	getStatusText(status: string): string {
		const texts = {
			Pendente: 'Pendente',
			'Em Andamento': 'Em Andamento',
			Concluído: 'Concluído',
			Incompleto: 'Incompleto',
		}
		return texts[status] || status
	}

	formatarData(data: string | Date): string {
		if (!data) return '-'
		const d = new Date(data)
		return isNaN(d.getTime()) ? '-' : d.toLocaleDateString('pt-BR')
	}

	formatarHora(data: string | Date): string {
		if (!data) return '-'
		const d = new Date(data)
		return isNaN(d.getTime())
			? '-'
			: d.toLocaleTimeString('pt-BR', {
				hour: '2-digit',
				minute: '2-digit',
			})
	}

	async visualizarProcessamento(arquivo) {

		try {
			
			const chaveAcesso = this.obterChaveNota(arquivo.itens[0].item);
			this.carregandoInicioDoProcessoDeImportacao = chaveAcesso

			if(!chaveAcesso){
				return AlertModule.setError('Chave de acesso da nota não encontrada. Acione o suporte!.')
			}

			this.importacaoDeNota = await this.importarNotaDoFornecedorUseCase.buscarImportacaoDeNota(chaveAcesso);

			if(this.importacaoDeNota && !this.importacaoDeNota.fornecedor.encontrado){
				const fornecedorCadastrado = await this.dialogoDeFornecedor.mostrar(
					{
						...this.importacaoDeNota.fornecedor.nota,
						id: '',
						tipoFornecedor: 'Compra',
						contrato: null,
						marca: null,
						gruposEconomicos: [],
						markup: 0,
						etiquetaPedido: null,
						isEntregaExpressa: false,
						endereco: {
							id: null,
							rua: '',
							numero: '',
							cep: '',
							bairro: '',
							complemento: '',
							cidade: '',
							codigoIBGE: '',
							uf: '' as any,
							codigoPais: '',
							nomePais: '',
						},
					},
					true,
				)
				if(!fornecedorCadastrado){
					this.importacaoDeNota = null
					this.carregandoInicioDoProcessoDeImportacao = null
					return
				}
				this.importacaoDeNota.fornecedor.encontrado = fornecedorCadastrado
			}

			if(this.importacaoDeNota){
				await Promise.all(
					this.importacaoDeNota.produtos
						.filter(produto => 
							produto.encontrado?.id && 
							produto.encontrado?.tipo === 'Com Variantes',
						)
						.map(async produto => {
							if(produto && produto.encontrado && produto.encontrado.tipo === 'Com Variantes'){
								const produtoCompleto = await this.findSkusUseCase.buscarVariantes(produto.encontrado.id)
								if (produtoCompleto) {
									produto.encontrado.variantes = produtoCompleto
								}
							}
						}),
				)

				if(this.importacaoDeNota.fornecedor.encontrado && this.importacaoDeNota.fornecedor.encontrado.markup > 0){
					this.margemDeLucroGeral = this.importacaoDeNota.fornecedor.encontrado.markup
					this.mostrarConfimacao()
				}

				this.importacaoDeNota.produtos.forEach(produto => {
					if (!produto.encontrado && this.podeCriarProduto) {
						produto.encontrado = this.montarProdutoParaCriacaoNaImportacao(produto)
					}

					if (produto.encontrado && !produto.encontrado.id && this.importacaoDeNota) {
						produto.encontrado.marca = this.importacaoDeNota.fornecedor.encontrado?.marca || null
					}
				})

				for (let i = 0;i < this.importacaoDeNota.produtos.length; i++) {
					this.importacaoDeNota.produtos[i].indice = i
				}

				this.importacaoDeNota.produtos.sort((produtoA, produtoB) => produtoA.nota.nItem - produtoB.nota.nItem)
			} else {
				AlertModule.setError('Não foi possível carregar os detalhes do processamento. Tente novamente mais tarde.')
				this.carregandoInicioDoProcessoDeImportacao = null
				return
			}

		} catch (error) {
			AlertModule.setError('Não foi possível iniciar os processos de importação. Tente novamente mais tarde.')
			this.carregandoInicioDoProcessoDeImportacao = null
			return
		} finally {
			this.carregandoStatusProcessamento = false
			this.snackbarText = 'Iniciando Importação da Nota: ' + this.obterNumeroNota(arquivo.itens[0].item);
			this.snackbarColor = 'success';
			this.snackbar = true;
			this.carregandoInicioDoProcessoDeImportacao = null
			this.buscarItensDeImportacao();
		}
	}

	async reprocessarArquivo(arquivo) {
		//TODO: Caso futuramente haja necessidade de reprocessar um arquivo com erro,
		//implementar a chamada para o backend aqui
		try {
			AlertModule.setInfo(`Reprocessando arquivo: ${this.obterNumeroNota(arquivo.itens[0].item)}`)
			arquivo.progresso = 0
			
		} catch (error) {
			AlertModule.setError(error)
		}
	}

	mostrarErro(arquivo) {
		this.arquivoComErro = {
			chNfe: this.obterNumeroNota(arquivo.itens[0].item),
			mensagemDeErro: arquivo.itens[0].mensagemDeErro,
		}

		this.dialogoErro = true
	}

	async removerArquivo(arquivo) {
		try{
			await this.importarNotaDoFornecedorUseCase.delete(arquivo.id)
			this.buscarItensDeImportacao()
			this.snackbarText = 'Registro removido com sucesso!';
			this.snackbarColor = 'success';
			this.snackbar = true;
		} catch(e) {
			AlertModule.setError(e)
		}
	}

	get tiposDeProdutos(): BuscaDeProdutoDropdown['filtros'] {
		return { tipos: ['Padrão', 'Variante', 'Composto'] }
	}

	enxutarImportacao(): ImportacaoDeNota {
		if (!this.importacaoDeNota) return this.importacaoDeNota as any

		const CAMPOS_PRODUTO = ['urlImagens', 'tags', 'familiasDoProduto', 'estacao', 'genero', 'marca', 'categoria']
		const CAMPOS_VARIANTE = ['urlImagens', 'tags', 'familiasDoProduto', 'varianteVinculada']

		const enxutarProduto = (produto: Produto | null): Produto | null => {
			if (!produto) return null
			const slim: any = { ...produto }
			CAMPOS_PRODUTO.forEach(campo => { slim[campo] = undefined })
			if (slim.tipo === 'Com Variantes' && slim.variantes) {
				slim.variantes = slim.variantes.map((v: any) => {
					const sv = { ...v }
					CAMPOS_VARIANTE.forEach(campo => { sv[campo] = undefined })
					return sv
				})
			}
			return slim as Produto
		}

		return {
			...this.importacaoDeNota,
			produtos: this.importacaoDeNota.produtos.map(p => ({
				...p,
				encontrado: enxutarProduto(p.encontrado),
				produtosAgrupados: p.produtosAgrupados?.map(pa => ({
					...pa,
					encontrado: enxutarProduto(pa.encontrado),
				})) ?? [],
			})),
		}
	}

	salvarNoLocalStorage() {
		try {
			const json = JSON.stringify(this.enxutarImportacao())
			const comprimido = LZString.compress(json)
			localStorage.setItem(IMPORTACAO_DE_NOTA, comprimido)
		} catch (e) {
			AlertModule.setError('Não foi possível salvar os dados temporários. O volume de dados é muito grande.')
		}
	}

	async salvarMapeamentoDeNotas() {
		if (!this.importacaoDeNota) return;
		if (this.importacaoDeNota.produtos.some(({ encontrado }) => !encontrado)) {
			AlertModule.setError('Existem produtos não associados');
			return;
		}
		if (!this.form.validate()) return;

		const skusDuplicados = this.verificarSkusDuplicados();
		if (skusDuplicados.length > 0) {
			AlertModule.setError(`Existem SKUs duplicados: ${skusDuplicados.join(', ')}. Corrija antes de finalizar.`);
			return;
		}

		try {
			this.enviando = true;

			this.importacaoDeNota.naoDeveAtualizarTabelaDePreco = this.naoDeveAtualizarTabelaDePreco
			this.importacaoDeNota.naoDeveMovimentarEstoque = this.naoDeveMovimentarEstoque

			const importacaoDeNotaBlob = new Blob([JSON.stringify(this.enxutarImportacao())], { type: 'application/json' });
			const importacaoDeNotaFile = new File([importacaoDeNotaBlob], 'importacaoDeNota.json', { type: 'application/json' });

			const informacoesDosArquivos = await uploadFilesToS3([importacaoDeNotaFile], 'importacao-de-notas');
			const urlDoArquivoJson = informacoesDosArquivos.map(({ config }) => config.url)[0];

			if (!urlDoArquivoJson) {
				return AlertModule.setError("Ocorreu um erro interno, contate o suporte");
			}

			const importacaoDeNotaFinalizada = await this.finalizarImportacaoDeNotaDoFornecedorUseCase.execute(urlDoArquivoJson, this.naoDeveMovimentarEstoque, this.naoDeveAtualizarTabelaDePreco);

			if (!importacaoDeNotaFinalizada.feedbackDosTitulos) {
				AlertModule.setSuccess('Processo de nota iniciado com sucesso!');
			} else {
				AlertModule.setInfo(`Processo de nota iniciado com sucesso, porém ${importacaoDeNotaFinalizada.feedbackDosTitulos}`);
			}

		} catch (error: any) {
			AlertModule.setError(error);
			return;
		} finally {
			this.enviando = false;
			this.limparIntegracaoDeNota()
		}
	}

	verificarSkusDuplicados(): string[] {
		if (!this.importacaoDeNota) return [];
		const todos: string[] = [];
		this.importacaoDeNota.produtos.forEach(produto => {
			const encontrado = produto as any;
			if (encontrado?.sku) todos.push(encontrado.sku);
		});
		const contagem = todos.reduce((acc, sku) => { acc[sku] = (acc[sku] || 0) + 1; return acc; }, {} as Record<string, number>);
		return Object.entries(contagem).filter(([, count]) => count > 1).map(([sku]) => sku);
	}

	limparIntegracaoDeNota() {
		localStorage.removeItem(IMPORTACAO_DE_NOTA)
		this.importacaoDeNota = null
	}

	async editarFornecedor() {
		if (!this.importacaoDeNota || !this.importacaoDeNota.fornecedor.encontrado) return
		const fornecedor = await this.dialogoDeFornecedor.mostrar(this.importacaoDeNota.fornecedor.encontrado, false)
		if (!fornecedor) return
		this.importacaoDeNota = {
			...this.importacaoDeNota,
			fornecedor: {
				...this.importacaoDeNota.fornecedor,
				encontrado: fornecedor,
			},
		}
	}

	@Watch('importacaoDeNota', { deep: true, immediate: true })
	onChangeIntegracaoDeNota() {
		if (this.importacaoDeNota) {
			this.importacaoDeNota.produtos.forEach(produto => {
				if (produto.encontrado && produto.encontrado.tipo === 'Com Variantes') {
					produto.quantidadeInformada = produto.encontrado.variantes ? produto.encontrado.variantes.map(variante => variante.quantidadeImportacao||0).reduce((total, valor) => total + valor) : 0
				} else {
					produto.quantidadeInformada = 0
				}
			})

			this.importacaoDeNota.quantidadesPreenchidasCorretamente = this.quantidadesInformadasValidas()
			this.onReloadFinalizar()
		}

		this.file = null
		this.salvarNoLocalStorage()
	}

	montarProdutoParaCriacaoNaImportacao(produtoDaImportacao: ProdutoDaImportacao): Produto {
		const precoDeCusto = Number(produtoDaImportacao.nota.vUnCom) || 0

		return {
			...criarProduto(),
			id: '',
			tipo: 'Padrão',
			nome: produtoDaImportacao.nota.xProd,
			sku: produtoDaImportacao.nota.cProd,
			eans: produtoDaImportacao.nota.cEAN ? [produtoDaImportacao.nota.cEAN] : [],
			ncm: {
				id: '',
				codigo: produtoDaImportacao.nota.NCM,
				descricao: '',
			},
			unidadeDeMedida: produtoDaImportacao.nota.uCom || 'UNID',
			precoCompra: precoDeCusto,
			preco: produtoDaImportacao.precoFinalVarejo || precoDeCusto,
			margemLucro: produtoDaImportacao.margemDeLucro || 0,
			identificadores: [],
			nomeCompleto: '',
		} as unknown as Produto
	}

	async abrirDialogoDeEditarProduto(produto: ProdutoDaImportacao, indiceEmEdicao: number) {
		this.indiceEmEdicao = indiceEmEdicao

		if (produto.encontrado && !produto.encontrado.precoCompra) {
			produto.encontrado.precoCompra = produto.encontrado.preco
			produto.encontrado.margemLucro = 0
		}

		this.produtoEmEdicao.margemLucro = produto.margemDeLucro

		if(produto.encontrado){
			this.produtoEmEdicao.precoCompra = produto.encontrado.precoCompra
			this.produtoEmEdicao = JSON.parse(JSON.stringify(produto.encontrado))

			if (this.produtoEmEdicao.tipo === 'Com Variantes') {
				normalizarValoresDosAtributosDoProduto(this.produtoEmEdicao.atributosProduto)
			}
		}
		
		this.produtoEmEdicao.preco = produto.precoFinalVarejo
		this.produtoEmEdicao.ncm = {
			id: '',
			descricao: '',
			codigo: produto.nota.NCM,
		}

		if(this.produtoEmEdicao && !this.produtoEmEdicao.tipo){
			(this.produtoEmEdicao as any).tipo = 'Padrão'
		}


		if (this.produtoEmEdicao) {
			if(this.produtoEmEdicao.tipo === 'Padrão'){
				(this.produtoEmEdicao as any) = {
					...this.produtoEmEdicao,
					sku: this.produtoEmEdicao.sku ? this.produtoEmEdicao.sku : produto.nota.cProd,
					nome: this.produtoEmEdicao.nome ? this.produtoEmEdicao.nome : produto.nota.xProd,
					unidadeDeMedida: this.produtoEmEdicao.unidadeDeMedida ? this.produtoEmEdicao.unidadeDeMedida : produto.nota.uCom,
					margemDeLucro: this.produtoEmEdicao.margemLucro ? this.produtoEmEdicao.margemLucro : 0,
					preco: this.produtoEmEdicao.preco ? this.produtoEmEdicao.preco : produto.nota.vUnCom,
					eans: this.produtoEmEdicao.eans ? this.produtoEmEdicao.eans : [produto.nota.cEAN],
				}
			}

			if(this.produtoEmEdicao && this.produtoEmEdicao.tipo === 'Com Variantes'){
				(this.produtoEmEdicao as any).encontrado = {
					...this.produtoEmEdicao,
					sku: this.produtoEmEdicao.sku ? this.produtoEmEdicao.sku : produto.nota.cProd,
					nome: this.produtoEmEdicao.nome ? this.produtoEmEdicao.nome : produto.nota.xProd,
					unidadeDeMedida: this.produtoEmEdicao.unidadeDeMedida ? this.produtoEmEdicao.unidadeDeMedida : produto.nota.uCom,
					margemDeLucro: this.produtoEmEdicao.margemLucro ? this.produtoEmEdicao.margemLucro : 0,
					preco: this.produtoEmEdicao.preco ? this.produtoEmEdicao.preco : produto.nota.vUnCom,
					eans: this.produtoEmEdicao.eans ? this.produtoEmEdicao.eans : [produto.nota.cEAN],
				}
			}
		}
		
		this.mostrarDialogoDeEdicaoDeProduto = true
	}

	async salvarProduto() {
		this.salvandoEdicaoDeProduto = true
		if (!this.importacaoDeNota) {
			this.salvandoEdicaoDeProduto = false
			return
		}

		if (!this.produtoEmEdicao.unidadeDeMedida || this.produtoEmEdicao.unidadeDeMedida === ''){
			this.salvandoEdicaoDeProduto = false
			return AlertModule.setError("Obrigatório informar unidade de medida")
		}

		const skusParaValidar: string[] = []
		if (this.produtoEmEdicao.tipo === 'Com Variantes') {
			this.produtoEmEdicao.variantes.forEach(variante => {
				if (!variante.id) skusParaValidar.push(variante.sku)
			})

			if (!this.produtoEmEdicao.id && this.produtoEmEdicao.sku) skusParaValidar.push(this.produtoEmEdicao.sku)
		}

		try {
			if (skusParaValidar.length > 0) {
				const skusJaExistentes = await this.findSkusUseCase.validarSkusJaExistentes({ skus: skusParaValidar })

				if (skusJaExistentes.length > 0) {
					AlertModule.setError(`Os SKUs ${skusJaExistentes.join(', ')} já existem`)
					this.salvandoEdicaoDeProduto = false
					return
				}
			}

			this.importacaoDeNota.produtos[this.indiceEmEdicao].encontrado = JSON.parse(JSON.stringify(this.produtoEmEdicao))
			this.importacaoDeNota.produtos[this.indiceEmEdicao].margemDeLucro = this.produtoEmEdicao.margemLucro || 0
			this.importacaoDeNota.produtos[this.indiceEmEdicao].precoFinalVarejo = this.arredondarPreco(this.produtoEmEdicao.preco || 0)
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.salvandoEdicaoDeProduto = false
		}

		this.fecharDialogoDeEdicaoDeProduto()
	}

	fecharDialogoDeEdicaoDeProduto() {
		this.produtoEmEdicao = {} as Produto
		this.indiceEmEdicao = 0
		this.mostrarDialogoDeEdicaoDeProduto = false
	}

	calculaPrecoVarejo() {
		if (!this.produtoEmEdicao) return
		
		const precoCompra = this.produtoEmEdicao.precoCompra || 0
		const margemDeLucro = 1 + (this.produtoEmEdicao.margemLucro || 0) / 100
		
		this.produtoEmEdicao.preco = this.arredondarPreco(round(
			(precoCompra * margemDeLucro ).toString(),
			2,
		))
	}

	formatarMenssagem() {
		return `
				<div><h2 class="formatarAviso">Aviso!</h2></div>
				<div class="mt-4">
					Você deseja continuar? 
					Se confirmar, todas as margens de lucro serão atualizadas
				</div>
			`
	}

	formatarMenssagemDasMarcas() {
		return `
				<div><h2 class="formatarAviso">Aviso!</h2></div>
				<div class="mt-4">
					Se confirmar, todos os produtos desta nota serão associados a esta marca
				</div>
			`
	}

	async mostrarConfimacao() {
		if(!this.importacaoDeNota) return
		if(!await this.confirmarAlteracaoDaMargemDeLucro.mostrar()) return
		
		this.inserirMargemDeLucroNosItens()
	}

	inserirMargemDeLucroNosItens() {
		if(!this.importacaoDeNota) return
		
		this.importacaoDeNota.produtos.forEach(produto => {
			produto.margemDeLucro = this.margemDeLucroGeral

			this.modificarMargemDeLucro(produto)
		})
	}

	formatarNumero(numero) {
		if(numero == null || numero == undefined) {
			return ''
		}
		return this.fixarCasasDecimais(parseFloat(numero), 2)
	}

	modificarMargemDeLucro(produto: ProdutoDaImportacao) {
		if (!produto) return

		if (produto.margemDeLucro === 0) {			
			produto.precoFinalVarejo = this.arredondarPreco(Number(produto.nota.vUnCom))
			return
		}

		const precoCompra = Number(produto.nota.vUnCom) || 0
		const margemDeLucro = 1 + (produto.margemDeLucro || 0) / 100

		const precoCalculado = round(
			(precoCompra * margemDeLucro).toString(),
			2,
		)

		const precoArredondado = this.arredondarPreco(precoCalculado)

		produto.precoFinalVarejo = round(precoArredondado.toString(), 2)
	}

	arredondarPreco(preco: number) {
		if (this.naoUtilizarArredondamentoDecimal) return preco

		const casasDecimais = preco - Math.floor(preco)
		
		let precoArredondado = Math.floor(preco)
		
		if (casasDecimais >= 0.50) {
			precoArredondado += this.margemArredondamentoAcima
		} else {
			precoArredondado += this.margemArredondamentoAbaixo
		}

		return precoArredondado
	}

	obterValorDoAtributo(variante, atributoEsperado) {
		const valorFiltrado =  variante.atributosVariante.filter(atributo => atributo.nome.toUpperCase() === atributoEsperado.toUpperCase())

		if (valorFiltrado.length > 0) {
			return valorFiltrado[0].valor
		}
		return 'Sem '+atributoEsperado
	}

	montarGradeDoProduto() {
		this.dialogoDeSelecaoDeGradeDeProdutos.mostrar()
	}

	adicionarCoresAoProduto() {
		this.dialogoDeAdicionarCor.mostrar(this.produtoEmEdicao)
	}

	async criarVariacoesDoProdutoEmEdicao(cores, tamanhos) {
		this.produtoEmEdicao.tipo = 'Com Variantes'

		if (this.produtoEmEdicao.tipo === 'Com Variantes') {
			try {
				this.gerandoVariantes = true
				const atributos = await this.findAtributosUseCase.findAll()
				
				const atributoCor = atributos.filter(atributo => atributo.nome.toUpperCase() === 'COR')[0]
				const atributoTamanho = atributos.filter(atributo => atributo.nome.toUpperCase() === 'TAMANHO')[0]

				this.produtoEmEdicao.atributosProduto = []

				this.produtoEmEdicao.atributosProduto.push({
					id: '',
					atributo: atributoCor,
					valores: cores,
					descontoVarejo: 0,
				} as AtributoDoProduto)

				this.produtoEmEdicao.atributosProduto.push({
					id: '',
					atributo: atributoTamanho,
					valores: tamanhos,
					descontoVarejo: 0,
				} as AtributoDoProduto)

				const variantes = this.criarVariantesDoProduto(Object.create(this.produtoEmEdicao), this.produtoEmEdicao.atributosProduto)

				this.produtoEmEdicao.variantes = variantes
			} catch(error) {
				AlertModule.setError(error)
			} finally {
				this.gerandoVariantes = false
			}
		}
	}

	async criarVariacoesDeCorDoProdutoEmEdicao(cores: string[]) {
		this.produtoEmEdicao.tipo = 'Com Variantes'

		if (this.produtoEmEdicao.tipo === 'Com Variantes') {
			try {
				this.gerandoVariantes = true

				const atributosProduto = normalizarValoresDosAtributosDoProduto(this.produtoEmEdicao.atributosProduto)

				const atributoDeCor = atributosProduto.find(
					atributo => normalizarValorDeAtributo(atributo.atributo?.nome).toUpperCase() === 'COR',
				)

				if (!atributoDeCor) {
					AlertModule.setError('Produto sem atributo de cor, adicione a grade do produto')
					return
				}

				const novasCores = cores
					.map(normalizarValorDeAtributo)
					.filter(cor => !!cor)
					.filter(cor => !atributoDeCor.valores.some(valor => valor.toUpperCase() === cor.toUpperCase()))

				if (!novasCores.length) return

				const atributosDeTamanho = atributosProduto.filter(
					atributo => normalizarValorDeAtributo(atributo.atributo?.nome).toUpperCase() === 'TAMANHO',
				)

				const novasVariantes = this.criarVariantesDoProduto(
					this.produtoEmEdicao,
					[
						...atributosDeTamanho,
						{ ...atributoDeCor, valores: novasCores },
					],
				)

				atributoDeCor.valores.push(...novasCores)

				for (const variante of novasVariantes) {
					this.produtoEmEdicao.variantes.push(variante)
				}
			} catch(error) {
				AlertModule.setError(error)
			} finally {
				this.gerandoVariantes = false
			}
		}
	}

	removerEspacos(str) {
		return str.replace(/\s+/g, "")
	}

	obterValorDaVariacao(variacao: Variacao, nomeDoAtributo: string) {
		const atributoDaVariante = variacao.find(
			atributo => normalizarValorDeAtributo(atributo.nome).toUpperCase() === nomeDoAtributo.toUpperCase(),
		)
		return normalizarValorDeAtributo(atributoDaVariante?.valor)
	}

	criarVariantesDoProduto(
		produto: Produto,
		atributos: AtributoDoProduto[],
	) {

		const atributosDaVariante = atributos
			.map(atributoDoProduto => ({
				...atributoDoProduto,
				valores: (atributoDoProduto.valores || [])
					.map(normalizarValorDeAtributo)
					.filter(valor => !!valor),
			}))
			.filter(({ valores }) => valores.length)
			.map(({ id, atributo, valores }) =>
				valores.map(valor => ({
					id,
					nome: atributo.nome,
					valor,
				})),
			)
		const variacoes: Variacao[] = cartesianProduct(atributosDaVariante)
		const variantes = variacoes.map<Variante>(variacao => ({
			id: '',
			ncm: null,
			cest: null,
			regraFiscal: null,
			idProdutoPai: produto.id,
			tipo: "Variante",
			tags: produto.tags,
			descricao: null,
			categoria: produto.categoria,
			urlImagens: produto.urlImagens,
			sku: produto.sku
				+ this.removerEspacos(this.obterValorDaVariacao(variacao, 'TAMANHO').toUpperCase())
				+ this.removerEspacos(this.obterValorDaVariacao(variacao, 'COR').toUpperCase()),
			preco: null,
			pesoLiquido: produto.pesoLiquido,
			pesoBruto: produto.pesoBruto,
			descontoVarejo: null,
			marca: produto.marca,
			nome: produto.nome,
			atributosVariante: variacao,
			temGarantia: produto.temGarantia,
			regrasFiscais: [],
			eans: [],
			unidadeDeMedida: produto.unidadeDeMedida,
			identificadores: [],
			produtoDesativado: produto.produtoDesativado,
			produtoIntegrado: produto.produtoIntegrado,
			genero: produto.genero,
			fatorDeConversao: produto.fatorDeConversao,
			unidadeDeConversao: produto.unidadeDeConversao,
			estacao: produto.estacao,
			isValePresente: false,
			skuPai: produto.skuPai,
			quantidadeImportacao: 0,
			fornecedor: produto.fornecedor,
			precoCompra: null,
			margemLucro: null,
			nomeCompleto: produto.nome + ' ' + this.obterValorDaVariacao(variacao, 'COR') + '/' + this.obterValorDaVariacao(variacao, 'TAMANHO'),
			familiasDoProduto: produto.familiasDoProduto,
			varianteVinculada: null,
			vinculada: false,
			produtoIncompleto: false,
			tipoDaOrigemDoProduto: 'Comprado',
			codigoOrigemDoProduto: 0,
		}))
		return variantes
	}

	async onReloadFinalizar() {
		if (!this.importacaoDeNota) return

		this.podeFinalizar = this.importacaoDeNota.produtos.filter(produto => produto.encontrado && produto.encontrado.tipo && produto.encontrado.tipo === 'Com Variantes').length > 0 
			&& !this.importacaoDeNota.quantidadesPreenchidasCorretamente
	}

	async aplicarMarcaEmTodosProdutos(marcaSelecionada: Marca, produtoDaImportacao: ProdutoDaImportacao) {
		if (!this.importacaoDeNota) return
		if (!marcaSelecionada) return

		const primeiroProdutoSelecionavel = this.importacaoDeNota.produtos.find(produto => 
			produto.encontrado !== null && !(produto.encontrado && produto.encontrado.id),
		)

		if (primeiroProdutoSelecionavel && primeiroProdutoSelecionavel.indice === produtoDaImportacao.indice) {
			if (await this.confirmarAlteracaoDasMarcas.mostrar()) {
				this.importacaoDeNota.produtos.forEach(produto => {
					if ((produto.encontrado !== null && !(produto.encontrado && produto.encontrado.id))) {
						produto.encontrado.marca = marcaSelecionada
					}
				})
			}
		}
	}

	regraMargemArredondamento = (v: number) => {
		if (v === null || v === undefined) return true
		return v >= 0.00 && v <= 0.99 || 'O valor deve estar entre 0.00 e 0.99'
	}

	async buscarItensDeImportacao(){
		if(!this.usuario) return
		this.carregandoStatusProcessamento = true

		try{
			this.arquivosEmProcessamento = await this.importarNotaDoFornecedorUseCase.buscarItensDeImportacao(this.usuario);
		}catch(error){
			AlertModule.setError(error)
		}finally{
			this.carregandoStatusProcessamento = false
		}
	}

	private extrairXmlDoItem(item: any): string {
		if (!item) return ''
		if (typeof item === 'string') {
			try {
				const json = JSON.parse(item)
				if (json && typeof json.xml === 'string') return json.xml
			} catch (e) {
				AlertModule.setError('Erro: ' + e)
			}
			return item
		}
		if (typeof item.xml === 'string') return item.xml
		return ''
	}

	obterNumeroNota(item: any): string | null {
		const xmlString = this.extrairXmlDoItem(item)
		if (!xmlString) return null

		const match = xmlString.match(/<nNF>(\d+)<\/nNF>/)
		return match ? 'Nº' + match[1] : null
	}

	obterChaveNota(item: any): string {
		const xmlString = this.extrairXmlDoItem(item)
		if (!xmlString) return ''

		const matchProtocolo = xmlString.match(/<chNFe>(\d+)<\/chNFe>/)
		if (matchProtocolo) return matchProtocolo[1]

		const matchInfNFe = xmlString.match(/Id="NFe(\d{44})"/)
		return matchInfNFe ? matchInfNFe[1] : ''
	}

	get modoNoturno() {
		return AppStore.modoNoturno
	}
}

